import { makeAutoObservable } from "mobx";
import type { RootStore } from "./root.store";
import {
  PROFILE_SETTINGS_TABS,
  type IProfileSettingsTab,
  type TProfileSettingsTabKey,
} from "@/lib/permissions/profile-permissions";

export class ProfileSettingsStore {
  private rootStore: RootStore;
  isOpen = false;
  activeTab: TProfileSettingsTabKey = "general";

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as never, { autoBind: true });
  }

  get tabs(): IProfileSettingsTab[] {
    return PROFILE_SETTINGS_TABS;
  }

  open(tab: TProfileSettingsTabKey = "general"): void {
    this.activeTab = tab;
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  setOpen(open: boolean): void {
    this.isOpen = open;
  }

  setActiveTab(tab: TProfileSettingsTabKey): void {
    this.activeTab = tab;
  }
}
